import React from 'react'

const AgendaOverview = () => {
  return (
    <div>
      <div className="py-8 grid md:grid-cols-3 gap-8">
        <div className="text-gray-500 text-left">
          <p className="text-lg">
            We&apos;ve designed the agenda to help you get the most out of your experience.
          </p>
          <p className="font-medium pt-4">Case Study Talks</p>
          <p className="text-sm">Learn how others are solving the same challenges that you face</p>
          <p className="font-medium pt-4">Targetted Workshops</p>
          <p className="text-sm">Upskill on the latest tools and techniques</p>
          <p className="font-medium pt-4">Deep Dive Forums</p>
          <p className="text-sm">Join a discussion on topics that interest you</p>
          <p className="font-medium pt-4">Fun Activities</p>
          <p className="text-sm">You know the saying: All work and no play.. </p>
        </div>

        <div className=" md:col-span-2">
          <div className="grid grid-cols-8 gap-6 pb-4">
            <div className="col-span-2 bg-sky-900 text-white px-1 py-2 sm:p-4 text-center rounded-lg font-bold uppercase break-all text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Get Inspired</p>
            </div>
            <div className="col-span-2 bg-sky-900 text-white px-1 py-2 sm:p-4 text-center rounded-lg font-bold uppercase break-all text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Learn</p>
            </div>
            <div className="col-span-2 bg-sky-900 text-white px-1 py-2 sm:p-4 text-center rounded-lg font-bold uppercase break-all text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Upskill</p>
            </div>
            <div className="col-span-2 bg-sky-900 text-white px-1 py-2 sm:p-4 text-center rounded-lg font-bold uppercase break-all text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Meet Peers</p>
            </div>
          </div>
          <div className="border border-dashed border-gray-500  mb-4" />
          <div className="grid grid-cols-8 grid-rows-4 gap-6">
            <div className="col-span-4 bg-emerald-500 text-white rounded-lg px-1 py-2 sm:p-4 text-center font-bold text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Talks</p>
            </div>

            <div className="col-start-4 col-span-3 bg-amber-500 text-white rounded-lg px-1 py-2 sm:p-4 text-center font-bold text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Workshops</p>
            </div>

            <div className="col-start-3 col-span-2 bg-pink-600 text-white rounded-lg px-1 py-2 sm:p-4 text-center font-bold text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Forums</p>
            </div>

            <div className="col-start-7 col-span-2 bg-pink-600 text-white rounded-lg px-1 py-2 sm:p-4 text-center font-bold text-xs sm:text-sm md:text-base flex items-center">
              <p className="text-center w-full">Forums</p>
            </div>

            <div className="col-start-7 col-span-2 bg-sky-600 text-white rounded-lg px-1 py-2 sm:p-4 text-center font-bold text-xs sm:text-sm break-all md:text-base flex items-center">
              <p className="text-center w-full">Activities</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgendaOverview
